import { render, staticRenderFns } from "./bandgroup.vue?vue&type=template&id=abf0f4c0&scoped=true"
import script from "./bandgroup.vue?vue&type=script&lang=js"
export * from "./bandgroup.vue?vue&type=script&lang=js"
import style0 from "./bandgroup.vue?vue&type=style&index=0&id=abf0f4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf0f4c0",
  null
  
)

export default component.exports